export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">爆料通道</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">投稿爆料</h2>
          <p className="text-foreground-600 text-sm mt-2">你有料，我有平台，一起吃瓜</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-10 max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-5">
            <i className="ri-mail-send-line text-2xl text-primary-600"></i>
          </div>
          <h3 className="text-lg font-bold text-foreground-900 mb-3">欢迎投稿，一起吃瓜</h3>
          <p className="text-sm text-foreground-600 leading-relaxed mb-6">
            如果你有娱乐圈、网红圈的第一手猛料，欢迎通过以下方式联系我们。你的爆料将经过严格核实后发布，严格保护爆料人隐私信息。51黑料网始终坚持做最真实的娱乐圈吃瓜第一线，期待你的独家投稿！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href="#contact" className="w-full sm:w-auto px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer transition-colors flex items-center justify-center gap-2">
              <i className="ri-send-plane-line"></i>立即投稿
            </a>
            <a href="#about" className="w-full sm:w-auto px-6 py-3 rounded-lg border border-background-300 text-foreground-700 hover:bg-background-100 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors flex items-center justify-center gap-2">
              <i className="ri-information-line"></i>了解投稿规则
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}